<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
			<!--table head-->
			<v-divider color="black" />
            <v-row class="subtitle-2" no-gutters>
                <v-col class="text-left"> {{'Segment' | localize}}</v-col>
                <v-divider vertical color="black" />
                <v-col v-for="(item, i) in headers"
                    class="text-pre-wrap"
                    :key="i" :class="item.style">
                    {{ `${item.title}` | localize }}
                </v-col>
            </v-row>
            <v-divider color="black" />
            
            <!--advanced features need tab-->
            <div v-if="advancedFeatures.length">
                <div v-for="af in advancedFeatures" :key="af.id">
                    <v-row class="body-2 my-1" no-gutters>
                        <v-col class="text-truncate text-left">{{ af.segment?.name }}</v-col>
                        <v-divider vertical />
                        <v-col class="text-center">{{ Math.round(af.positioning_acceptance * 100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.power_bank_acceptance * 100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.missed_items_warning_acceptance *
                            100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.danger_alarm_acceptance * 100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.fridge_camera_acceptance * 100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.loss_insurance_acceptance * 100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.friendly_utilization_acceptance *
                            100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.profit_sharing_acceptance * 100)}}%</v-col>
                        <v-col class="text-center">{{ Math.round(af.individual_pictures_acceptance * 100)}}%</v-col>
                    </v-row>
                    <v-divider />
                </div>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no advanced features acceptance yet
            </v-row>
        </div>
        <!--!loading-->
        <v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row>	
    </v-container>
</template>
<script>

import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue'

export default {
    data() {
        return {
            headers: [
                { title: 'Positioning tracker', style: 'text-center' },
                { title: 'Power bank', style: 'text-center' },
                { title: 'Missed items warning', style: 'text-center' },
                { title: 'Danger alarm', style: 'text-center' },
                { title: 'Fridge camera', style: 'text-center' },
                { title: 'Loss insurance', style: 'text-center' },
                { title: 'Environment friendly utilization', style: 'text-center' },
                { title: 'Charity profit sharing', style: 'text-center' },
                { title: 'Individual pictures', style: 'text-center' },
            ],
            text: 'The functional expansion assessment reflects the percentage of consumers in each market segment who value specific product features introduced by producers.'
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        game() {
            return this.$store.getters.game
        },
        locale() {
            return this.$store.getters.locale;
        },
        advancedFeatures() {
            return this.$store.getters.advancedFeatures;
        }
    },
    methods: {
        
    },
    components: {
        Loader, Information
    },
    async created() {
        if (this.advancedFeatures?.length < 1 && this.game && this.game.round > 0) {

            const params = {
                gameId: this.game.id,
                round: this.game.round - 1,
            }
            try {
                await this.$store.dispatch('fetchAdvancedFeatures', params);
            } catch (error) {
                await this.$store.dispatch('setError', error.message);
            }  
        }
    }
}
</script>
